<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      d="M23.25 12.75L5.75 21.25V13.75L8.25 12.75L5.75 11.75V4.25L23.25 12.75ZM7.75 10.3955L8.99316 10.8926L13.6348 12.75L8.99316 14.6074L7.75 15.1045V18.0557L18.6729 12.75L7.75 7.44434V10.3955Z"
      fill="currentColor"
    />
  </svg>
</template>
